import { render, staticRenderFns } from "./Studios.vue?vue&type=template&id=b0668124"
import script from "./Studios.vue?vue&type=script&lang=js"
export * from "./Studios.vue?vue&type=script&lang=js"
import style0 from "./Studios.vue?vue&type=style&index=0&id=b0668124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports